import { snakeCase } from "lodash";
import api from "PFCore/api";
import { LocalisationEntry, LocalisationKeys } from "PFTypes";
import { Id } from "PFTypes";

export const editLocalisationKeys = (
  accountId: Id,
  key: LocalisationKeys,
  entryId: Id,
  localisation: LocalisationEntry[]
) =>
  api({
    url: `saas_admin/accounts/${accountId}/localisation/${snakeCase(key)}/${entryId}`,
    method: "PUT",
    data: {
      localisation
    }
  });
